import $ from 'jquery';
import { scrollToElement } from './lib/utilities';

hbspt.forms.create({
  target: '#hubspot-manage-subscriptions-form',
  portalId: '3572053',
  formId: '88163805-af62-4a88-9010-12722a816b46',
  onFormSubmit: () => scrollToElement($('#hubspot-manage-subscriptions-form'))
});
